import { EventType } from '../../../types/events/common.types';

export enum EventMenuType {
  ALL = 'all',
  REFERRAL = 'referral',
  TRADING = 'trading',
  AMA = 'ama',
  FINISHED = 'finished',
}

export type CustomEventAction = 'wheel-of-fortune' | 'daily-rewards';

export type EventListItem = Omit<import('routes/referral/types/events-list-api.types').EventListItem, 'event_type'> & {
  event_type: EventType;
  _customAction?: CustomEventAction;
};

export type EventSortBy = 'newest' | 'earliest' | 'trending' | 'low_activity';
export type EventStatusId = 0 | 1 | 2 | 3 | 4;
export type EventListMode = 'open' | 'whitelisted' | 'blacklisted';
export type RewardType = 'rmv' | 'nft' | 'spins';

export interface EventsListParams {
  search?: string;
  ordering?: string;
  visible?: boolean;
  highlighted?: boolean;
  status?: EventStatusId | EventStatusId[];
  reward_type?: RewardType | RewardType[];
  list_mode?: EventListMode[];
  event_type?: EventType[];
  event_label?: 'vip' | null;
  start_after?: string;
  start_before?: string;
  end_after?: string;
  end_before?: string;
  page?: number;
  page_size?: number;
}

export interface EventsListFilters {
  sortBy?: EventSortBy;
  status?: EventStatusId[];
  vipOnly?: boolean;
  rewardType?: RewardType[];
  eventType?: EventType[];
  search?: string;
}

export interface EventsListApiResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: EventListItem[];
}
